/* import __COLOCATED_TEMPLATE__ from './sales-agent-state-filter.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { action } from '@ember/object';
import { AiContentState } from 'embercom/lib/ai-content-library/constants';

interface SalesAgentStateFilterSignature {
  Args: {
    doSearch: (salesAgentState?: string) => void;
    selectedSalesAgentStateValue?: string;
    activeFilter?: string;
    removeFilter: (salesAgentState?: string) => void;
  };
}

export default class SalesAgentStateFilter extends Component<SalesAgentStateFilterSignature> {
  @service declare intl: IntlService;

  get isOpen() {
    return this.args.activeFilter === 'salesAgentState' && !this.args.selectedSalesAgentStateValue;
  }

  get salesAgentStates() {
    return [
      {
        text: this.intl.t('knowledge-hub.filterable-list.filters.sales-agent-state.enabled'),
        value: String(AiContentState.USED_BY_FIN),
      },
      {
        text: this.intl.t('knowledge-hub.filterable-list.filters.sales-agent-state.disabled'),
        value: String(AiContentState.NOT_USED_BY_FIN),
      },
    ];
  }

  get selectedSalesAgentState() {
    let salesAgentState = this.salesAgentStates.find(
      (state) => state.value === this.args.selectedSalesAgentStateValue,
    );
    return !salesAgentState?.value
      ? this.intl.t('knowledge-hub.filterable-list.filters.sales-agent-state.any-sales-agent-state')
      : salesAgentState.text;
  }

  @action removeFilter() {
    this.args.doSearch();
    this.args.removeFilter();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Filters::SalesAgentStateFilter': typeof SalesAgentStateFilter;
    'knowledge-hub/filterable-list/filters/sales-agent-state-filter': typeof SalesAgentStateFilter;
  }
}
